/** Resolve Amplify's authentication, identity and storage settings for this build.
 * UAT settings are explicit because the checked-in Amplify export contains
 * production defaults. Missing UAT configuration must never fall back to prod.
 */
import generatedConfig from './aws-exports';

export function resolveAuthConfig(base, env) {
  if (env.REACT_APP_ENV !== 'uat2') return base;
  const required = [
    'REACT_APP_COGNITO_USER_POOL_ID',
    'REACT_APP_COGNITO_CLIENT_ID',
    'REACT_APP_COGNITO_IDENTITY_POOL_ID',
    'REACT_APP_USER_FILES_BUCKET',
    'REACT_APP_PINPOINT_APP_ID',
  ];
  if (required.some((key) => !env[key])) {
    throw new Error('UAT authentication configuration is incomplete. Build with build:uat.');
  }
  return {
    ...base,
    aws_project_region: 'eu-west-1',
    aws_cognito_region: 'eu-west-1',
    aws_user_pools_id: env.REACT_APP_COGNITO_USER_POOL_ID,
    aws_user_pools_web_client_id: env.REACT_APP_COGNITO_CLIENT_ID,
    aws_cognito_identity_pool_id: env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    aws_user_files_s3_bucket: env.REACT_APP_USER_FILES_BUCKET,
    aws_user_files_s3_bucket_region: 'eu-west-1',
    aws_mobile_analytics_app_id: env.REACT_APP_PINPOINT_APP_ID,
    aws_mobile_analytics_app_region: 'eu-west-1',
    Analytics: { AWSPinpoint: { appId: env.REACT_APP_PINPOINT_APP_ID, region: 'eu-west-1' } },
  };
}

export default resolveAuthConfig(generatedConfig, process.env);
